var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveState({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_115",
    "data-name": "Ellipse 115",
    cx: 13,
    cy: 13,
    r: 13,
    transform: "translate(26 549)",
    fill: "#B1040E"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_95",
    "data-name": "Mask Group 95",
    transform: "translate(-26 -549)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_01-home",
    "data-name": "01-home",
    transform: "translate(30.541 551.125)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "glyph",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1440",
    "data-name": "Path 1440",
    d: "M11.554.206A8.468,8.468,0,0,0,3.1,8.665c0,2.266,1.373,5.175,4.08,8.648a46,46,0,0,0,4.021,4.5.518.518,0,0,0,.716,0,46,46,0,0,0,4.021-4.5c2.707-3.472,4.08-6.382,4.08-8.648A8.468,8.468,0,0,0,11.554.206Zm0,14.5A6.042,6.042,0,1,1,17.6,8.665,6.049,6.049,0,0,1,11.554,14.707Z",
    transform: "translate(-3.095 -0.206)",
    fill: "#B1040E"
  }))), /*#__PURE__*/React.createElement("text", {
    id: "S",
    transform: "translate(39 563)",
    fill: "#B1040E",
    fontSize: 9,
    fontFamily: "Poppins-Regular, Poppins"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -2,
    y: 0
  }, "S")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveState);
export default __webpack_public_path__ + "static/media/activeState.f8a0612fbc2df879cabec920041e208f.svg";
export { ForwardRef as ReactComponent };